// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const LicenseTypeSchema = z.enum(['pov','customer','internal'] as const);

export type LicenseTypeType = `${z.infer<typeof LicenseTypeSchema>}`

export default LicenseTypeSchema;
